export default function () {
    const navItems = [
        {
            title: '海洋廢棄物現況',
            items: [
                {
                    title: '海洋廢棄物統計',
                    routeUrl: { name: 'Statistics' },
                },
                {
                    title: '淨灘活動查詢',
                    routeUrl: { name: 'Activities' },
                },
            ],
        },
        {
            title: '循環供應鏈',
            items: [
                {
                    title: '循環供應鏈介紹',
                    routeUrl: { name: 'SupplyChainIntro' },
                },
                {
                    title: '加入循環供應鏈',
                    routeUrl: { name: 'SupplyChainJoin' },
                },
            ],
        },
        {
            title: '循環產品標章',
            items: [
                {
                    title: '循環產品標章介紹',
                    routeUrl: { name: 'CycleBadgeIntro' },
                },
                {
                    title: '申請進度與狀態查詢',
                    routeUrl: { name: 'CycleBadgeProgress' },
                },
                {
                    title: '循環產品標章案例',
                    routeUrl: { name: 'CycleBadgeCaseList' },
                },
            ],
        },
        {
            title: '資訊與服務',
            items: [
                {
                    title: '文件下載專區',
                    routeUrl: { name: 'InformationDocument' },
                },
                {
                    title: '圖片下載專區',
                    routeUrl: { name: 'InformationImage' },
                },
                {
                    title: '影音專區',
                    routeUrl: {
                        name: 'InformationVideo',
                    },
                },
            ],
        },
    ]
    const enNavItems = [
        {
            title: 'Current status of marine debris',
            items: [
                {
                    title: 'Statistics of marine debris',
                    routeUrl: { name: 'EnStatistics' },
                },
                {
                    title: 'Join a beach cleanup ',
                    href: 'https://ecolife2.moenv.gov.tw/coastal/SeaCalendar/SeaCalendar',
                },
            ],
        },
        {
            title: 'Recycling supply chain',
            items: [
                {
                    title: 'Create value from marine debris',
                    routeUrl: { name: 'EnSupplyChainIntro' },
                },
            ],
        },
        {
            title: 'Recycled marine debris product label',
            items: [
                {
                    title: 'Apply for a recycled marine debris product label',
                    routeUrl: { name: 'EnCycleBadgeIntro' },
                },
                {
                    title: 'Check the application progress and status',
                    routeUrl: { name: 'EnCycleBadgeProgress' },
                },
                {
                    title: 'Examples of recycled marine debris product',
                    routeUrl: { name: 'EnCycleBadgeCaseList' },
                },
            ],
        },
        {
            title: 'Multimedia',
            items: [
                {
                    title: 'Photo gallery',
                    routeUrl: { name: 'EnInformationImage' },
                },
                {
                    title: 'Video sharing',
                    routeUrl: {
                        name: 'EnInformationVideo',
                    },
                },
            ],
        },
    ]
    return { navItems, enNavItems }
}
